module.exports = __webpack_public_path__ + "static/media/bh.c47c4db1.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bh.svg
// module id = 605
// module chunks = 0